import type { GTM } from "./GTMInterfaces";

export function outputEventAdapter(event: GTM.EventExtendend): GTM.Event {
  delete event.onceForSession;

  return event;
}
